import { IonGrid, IonRow, IonCol, IonImg } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Dialog } from '@material-ui/core';
import { Carousel } from 'react-responsive-carousel';
import { connect } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import ClearIcon from '@material-ui/icons/Clear';
import { RootState } from '../../models/RootState';
import HomeView from '../../constants/HomeView';
import { getMobBanners, getWebBanners } from '../../constants/banner';
import CasinoView from '../../constants/CasinoView';
import Footer from '../Footer/Footer';
import { getCurrencyTypeFromToken, FatchLiveCasinoGames } from '../../store';
import Modal from '../Modal/Modal';
import LoginForm from '../LoginForm/LoginForm';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import ExchangeSportsListNav from '../ExchSportsListNav/ExchangeSportsListNav';
import './Home.scss';
import inplay from '../../assets/images/common/icons/Polygon.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { GapGame } from '../../models/dc/DcGame';
import { BRAND_DOMAIN, BRAND_NAME } from '../../constants/Branding';
import API_V2 from '../../api-services/svls-api';
import { AuthResponse } from '../../models/api/AuthResponse';

const Images = HomeView.HOME_PAGE_IMAGES;
const WebBanners = getWebBanners(BRAND_NAME);
const MobBanners = getMobBanners(BRAND_NAME);
const CasinoCards = HomeView.CASINO_WEB_NAV_PROVIDERS;
// const WLBanners = HomeView.WHITE_LABEL_BANNERS;
// const MobWLBanners = HomeView.WHITE_LABEL_BANNERS_MOBILE;

const POPULARGAMES = [
  Images.blackjack,
  Images.autoroulette,
  Images.baccaratLive,
  Images.rouletteLive,
  Images.wheelOfFortune,
  Images.Cards32,
  Images.dragontiger,
  Images.roulette,
  Images.speed_auto_roulette,
  Images.houseOfDragons,
  Images.bet_on_teen_patti,
  Images.rct,
];

type StoreProps = {
  loggedIn: boolean;
  allowedConfig: number;
  FatchLiveCasinoGames: (type: string) => void;
  liveCasinoGames: GapGame[];
  loggedInUserStatus: any;
};

const Home: React.FC<StoreProps> = (props) => {
  const {
    loggedIn,
    allowedConfig,
    FatchLiveCasinoGames,
    liveCasinoGames,
    loggedInUserStatus,
  } = props;
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalTitle] = useState('Login');
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [selectedEvolutionGame, setSelectedEvolutionGame] = useState(null);
  const [infoDialog, setInfoDialog] = useState<boolean>(false);
  const [gameId, setGameId] = useState<string>('');
  const [gameName, setName] = useState<string>('');

  const [webBanners, setWebBanners] = useState([]);
  const [mobBanners, setMobBanners] = useState([]);

  const history = useHistory();

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const getGameUrl = async (gameInfo: string, gameName: string) => {
    if (loggedIn) {
      const gameId = parseInt(gameInfo.split(':')[0], 10);
      const gameCode = gameInfo.split(':')[1];
      const provider = gameInfo.split(':')[2];
      const subProvider = gameInfo.split(':')[3];
      if (
        getCurrencyTypeFromToken() === 0 &&
        (subProvider.toLowerCase() === 'evolution gaming'||subProvider.toLowerCase() === 'spribe')
      ) {
        setSelectedEvolutionGame({
          gameId,
          gameName,
          gameCode,
          provider,
          subProvider,
        });
        setInfoDialog(true);
        return;
      }
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/gap_casino/game/${gameName
            .toLowerCase()
            .replace(/\s+/g, '-')}-${btoa(gameId.toString())}-${btoa(
            gameCode
          )}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    }
  };

  const showInfoDialog = (gameInfo: string, gameName: string) => {
    const provider = gameInfo.split(':')[2];
    if (loggedIn) {
      setGameId(gameInfo);
      setName(gameName);
      if (Number(getCurrencyTypeFromToken()) === 1) {
        getGameUrl(gameInfo, gameName);
      } else {
        if (
          getCurrencyTypeFromToken() === 0 &&
          gameInfo.split(':')[3] !== 'EZUGI'
        ) {
          setInfoDialog(true);
        } else {
          getGameUrl(gameInfo, gameName);
        }
      }
    } else {
      setShowDialog(true);
    }
  };

  const closeInfoDialog = () => {
    setInfoDialog(false);
  };
  const openIframe = () => {
    getGameUrl(gameId, gameName);
  };

  useEffect(() => {
    FatchLiveCasinoGames('virtual');
    fetchBannerData();
  }, []);

  const settings = {
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 500,
    pauseOnHover: true,
  };

  let virtualGames = liveCasinoGames.filter(
    (g) => g.providerName?.toLowerCase() === 'vsbr'
  );

  const getGameUrlVirtualGames = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      console.log(loggedInUserStatus);
      if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
        history.push(`/home`);
      } else {
        history.push(
          `/gap_casino/game/${gameName
            .toLowerCase()
            .replace(/\s+/g, '-')}-${btoa(gameId.toString())}-${btoa(
            gameCode
          )}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setShowDialog(true);
    }
  };

  const ShowNotificationWindow = (data) => {
    if (
      data?.redirectionUrl == '/exchange_sports/inplay' ||
      data?.redirectionUrl == '/casino' ||
      data?.redirectionUrl == '/exchange_sports/cricket' ||
      data?.redirectionUrl == '/exchange_sports/tennis' ||
      data?.redirectionUrl == '/exchange_sports/football'
    ) {
      history.push(data?.redirectionUrl);
    } else if (data?.redirectionUrl == 'nourl') {
    } else if (data.url) {
      if (BRAND_NAME.toLocaleLowerCase() == 'windaddy') {
        window.open('https://wa.link/windaddyco', '_blank');
      } else if (BRAND_NAME.toLocaleLowerCase() == 'sky11') {
        window.open('https://wa.link/sky11', '_blank');
      }
    } else {
      let url = data?.redirectionUrl;
      window.open(url, '_blank');
    }
  };

  const fetchBannerData = async () => {
    let webdata = [];
    let mobiledata = [];
    try {
      const response: AuthResponse = await API_V2.get(
        `/account/v2/books/${BRAND_DOMAIN}/banners`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            status: 'active',
            type: '*',
            category: 'homebanner',
          },
        }
      );
      let data = response?.data?.banners;
      if (data?.length > 0) {
        data.map((item) => {
          if (item.deviceType === 'desktop') {
            webdata.push(item);
          } else if (item.deviceType === 'mobile') {
            mobiledata.push(item);
          }
        });
        setWebBanners(webdata);
        setMobBanners(mobiledata);
      }
      if (webdata.length == 0) {
        setWebBanners(
          WebBanners.filter((m) => (m.configPermission & allowedConfig) !== 0)
        );
      }
      if (mobiledata.length == 0) {
        setMobBanners(
          MobBanners.filter((m) => (m.configPermission & allowedConfig) !== 0)
        );
      }
      console.log(webBanners.length, mobBanners.length);
    } catch (err) {
      if (webdata.length == 0) {
        setWebBanners(
          WebBanners.filter((m) => (m.configPermission & allowedConfig) !== 0)
        );
      }
      if (mobiledata.length == 0) {
        setMobBanners(
          MobBanners.filter((m) => (m.configPermission & allowedConfig) !== 0)
        );
      }
      console.log(err);
      //setShowError(true);
      if (err.response && err.response.status === 400) {
        //setErrorText(err.response.data.message);
      } else {
        //setErrorText('Something went wrong');
      }
    }
  };
  return (
    <>
      <div className="home-page-ctn">
        <div className="page-banner-ctn">
          <IonRow className="banners-row">
            <Carousel
              className="home-banners web-view"
              autoPlay={true}
              infiniteLoop={true}
              interval={5000}
              showThumbs={false}
              showStatus={false}
            >
              {webBanners.map((banner) => (
                <div key={banner?.text + 'container'}>
                  <img
                    className="banner-images"
                    src={banner?.publicUrl}
                    key={banner?.text + 'image'}
                    alt={'banner'}
                    loading="lazy"
                    onClick={() => ShowNotificationWindow(banner)}
                  />
                </div>
              ))}
            </Carousel>
            <Carousel
              className="home-banners mob-view"
              autoPlay={true}
              infiniteLoop={true}
              interval={5000}
              showThumbs={false}
              showStatus={false}
            >
              {mobBanners.map((banner) => (
                <div key={banner.text + 'container'}>
                  <img
                    onClick={() => ShowNotificationWindow(banner)}
                    className="banner-images"
                    src={banner.publicUrl}
                    key={banner.text + 'image'}
                    alt={'banner'}
                    loading="lazy"
                  />
                </div>
              ))}
            </Carousel>
          </IonRow>
        </div>

        <IonGrid class="home-grid">
          <ExchangeSportsListNav />

          <div className="card web-view">
            <div className="carw">
              <div className="arrow arrow-right">
                <span className="color-active">Popular</span> Games
              </div>
            </div>
            {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
              <>
                <IonRow>
                  {POPULARGAMES.map((game) => (
                    <IonCol
                      sizeXs="4"
                      sizeSm="4"
                      sizeMd="2"
                      sizeLg="2"
                      class="live-game container"
                      key={game.text}
                    >
                      <img
                        className="grid-images image"
                        src={game.image}
                        loading="lazy"
                        alt={game.text}
                      />
                      <div className="middle">
                        {loggedIn ? (
                          <div
                            className="custom-btn btn-play"
                            onClick={() => {
                              // showInfoDialog(game.id, game.text);
                              getGameUrl(game.id, game.text);
                            }}
                          >
                            <img src={inplay} alt="inplay" />
                          </div>
                        ) : (
                          <div
                            className="custom-btn btn-play"
                            onClick={() => setShowDialog(true)}
                          >
                            <img src={inplay} alt="inplay" />
                          </div>
                        )}
                      </div>
                    </IonCol>
                  ))}
                </IonRow>
              </>
            ) : null}
          </div>
          <div className="card mt-10">
            <div className="carw">
              <div className="arrow arrow-right">
                <span className="color-active">Live</span> Games
              </div>
            </div>

            <div className="title-card">
              <span className="active-text">20</span> Live Casino Games
            </div>
            {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
              <>
                <Slider {...settings}>
                  {POPULARGAMES.map((game) => (
                    <div
                      key={game.text}
                      onClick={() => {
                        // showInfoDialog(game.id, game.text);
                        getGameUrl(game.id, game.text);
                      }}
                    >
                      <img
                        className="virtual-images"
                        src={game.image}
                        loading="lazy"
                        alt={game.text}
                      />
                    </div>
                  ))}
                </Slider>
              </>
            ) : null}
          </div>
          {virtualGames?.length > 0 && (
            <div className="card mt-10">
              <div className="carw">
                <div className="arrow arrow-right">
                  <span className="color-active">Virtual</span> Games
                </div>
              </div>
              <div className="title-card">
                <span className="active-text">10</span> Indian Virtual Games{' '}
              </div>
              {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
                <>
                  <Slider {...settings}>
                    {virtualGames.map((game) => (
                      <div
                        key={game.gameName}
                        onClick={() =>
                          getGameUrlVirtualGames(
                            game.gameId,
                            game.gameName,
                            game.gameCode,
                            game.providerName,
                            game.subProviderName
                          )
                        }
                      >
                        <img
                          className="virtual-images"
                          src={game?.urlThumb}
                          loading="lazy"
                          alt={game.gameName}
                        />
                      </div>
                    ))}
                  </Slider>
                </>
              ) : null}
            </div>
          )}

          <div className="card mob-view mt-10">
            <div className="carw">
              <div className="arrow arrow-right">
                <span className="color-active">Popular</span> Games
              </div>
            </div>
            {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
              <>
                <IonRow>
                  {POPULARGAMES.map((game) => (
                    <IonCol
                      sizeXs="4"
                      sizeSm="4"
                      sizeMd="2"
                      sizeLg="2"
                      class="live-game container"
                      key={game.text}
                    >
                      <img
                        className="grid-images image"
                        src={game.image}
                        loading="lazy"
                        alt={game.text}
                      />
                      <div className="middle">
                        {loggedIn ? (
                          <div
                            className="custom-btn btn-play"
                            onClick={() => {
                              getGameUrl(game.id, game.text);
                            }}
                          >
                            <img src={inplay} alt="inplay" />
                          </div>
                        ) : (
                          <div
                            className="custom-btn btn-play"
                            onClick={() => setShowDialog(true)}
                          >
                            <img src={inplay} alt="inplay" />
                          </div>
                        )}
                      </div>
                    </IonCol>
                  ))}
                </IonRow>
              </>
            ) : null}
          </div>
          <div className="provider-title mt-5">All Providers</div>
          <div className="provider-card web-view">
            {CasinoCards.map((card, idx) => (
              <div
                className="small-card"
                onClick={() => history.push(card.url)}
              >
                {' '}
                <IonImg src={card.image} className="img-card" />
              </div>
            ))}
          </div>
          <div className="provider-card mob-view">
            {CasinoCards.filter((item) => item.text !== 'removo-mob').map(
              (card, idx) => (
                <div
                  className="small-card"
                  onClick={() => history.push(card.url)}
                >
                  <img src={card.image} className="img-card" />
                </div>
              )
            )}
          </div>
        </IonGrid>
        <Footer></Footer>
      </div>

      <Modal
        open={modalOpen}
        title={modalTitle}
        closeHandler={modalCloseHandler}
        size="xs"
        customClass={'login-modal-ctn'}
      >
        <LoginForm modalCloseHandler={modalCloseHandler}></LoginForm>
      </Modal>

      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-labelledby="form-dialog-title"
        className="dialog-div1"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => setShowDialog(false)}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>
          <div className="dialog-body">
            <div className="dialog-title">Notice</div>

            <p className="dialog-ex">You have to be logged in to play</p>
          </div>

          <div className="dialog-continue" onClick={() => setShowDialog(false)}>
            <div className="custom-btn btn">OK</div>
          </div>
        </div>
      </Dialog>
      {/* <Dialog
        open={infoDialog}
        onClose={() => closeInfoDialog()}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => closeInfoDialog()}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>
          {getCurrencyTypeFromToken() === 0 ? (
            <div className="dialog-body">
           
              <img src={casinobg} />

              <p className="dialog-ex">
                Maximum Bet limit is 5000 casino points
              </p>
            </div>
          ) : null}

          {getCurrencyTypeFromToken() === 1 ? (
            <>
              {' '}
              <div className="dialog-body">
                <img src={casinobg} />
                <div className="dialog-ex">
                  {' '}
                  Maximum Bet Limit For All Games is 5000
                </div>
              </div>
            </>
          ) : null}

          <div className="dialog-continue" onClick={() => openIframe()}>
            <div className="custom-btn">Continue</div>
          </div>
        </div>
      </Dialog> */}

      <Dialog
        open={infoDialog}
        onClose={() => {
          setInfoDialog(false);
          setSelectedEvolutionGame(null);
        }}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="dialog-title">Game Info</div>
          <div className="dialog-body">
            1 Casino Point is equal to 10 Normal Points.
            <div className="dialog-ex">
              {' '}
              Ex: 100 Casino Points = 1000 Points
            </div>
          </div>
          <div className="dialog-continue">
            <div
              className="custom-btn btn"
              onClick={() => {
                history.push(
                  `/gap_casino/game/${selectedEvolutionGame.gameName
                    .toLowerCase()
                    .replace(/\s+/g, '-')}-${btoa(selectedEvolutionGame.gameId.toString())}-${btoa(
                    selectedEvolutionGame.gameCode
                  )}-${btoa(selectedEvolutionGame.provider)}-${btoa(
                    selectedEvolutionGame.subProvider
                  )}`
                );
              }}
            >
              Continue
            </div>

            <div
              className="custom-btn-close"
              onClick={() => {
                setInfoDialog(false);
                setSelectedEvolutionGame(null);
              }}
            >
              Close
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  let status = 0;
  if (state.auth.loggedIn) {
    status = JSON.parse(
      window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
    ).status;
  }
  return {
    loggedIn: state.auth.loggedIn,
    allowedConfig: state.common.allowedConfig,
    liveCasinoGames: state.indianCasino.liveCasinoGames,
    loggedInUserStatus: status,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    FatchLiveCasinoGames: (type: string) =>
      dispatch(FatchLiveCasinoGames(type)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
